import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';

export default class ConfirmationDialog extends Component {
  handleCancel = () => {
    this.props.onClose('cancel');
  };

  handleOk = () => {
    this.props.onClose('ok');
  };

  render() {
    const { cancelLabel, okLabel, title, children, ...other } = this.props;
    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        onEntering={this.handleEntering}
        aria-labelledby="confirmation-dialog-title"
        aria-describedby="confirmation-dialog-description"
        {...other}
      >
        <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmation-dialog-description">
            {children}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.handleCancel}
            color="secondary"
            name="cancel"
            data-testid="btn-cancel-confirmation"
          >
            {cancelLabel || 'Cancel'}
          </Button>
          <Button
            onClick={this.handleOk}
            color="primary"
            name="ok"
            variant="contained"
            data-testid="btn-ok-confirmation"
          >
            {okLabel || 'Ok'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ConfirmationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};
